<section class="cmn-innerpage-wrapper new-chart-accounts">
  <h2 class="cmn-inner-heading">
    {{ accountId ? "Edit" : "Add" }}
    {{ isCreditCard ? "Credit Card" : "Bank Account" }}
  </h2>
  <form [formGroup]="addBankAccountForm">
    <label *ngIf="!accountId" class="radio-label"
      >Select Account Type <span class="red">*</span></label
    >
    <!-- Format Selection -->
    <div class="type-selection" *ngIf="!accountId">
      <label class="radiobtn-wrapper">
        <input
          type="radio"
          name="bankType"
          value="Bank"
          formControlName="bankType"
        />
        <span class="radiomark"></span>
        Bank
      </label>
      <label class="radiobtn-wrapper">
        <input
          type="radio"
          name="bankType"
          value="Credit"
          formControlName="bankType"
        />
        <span class="radiomark"></span>
        Credit Card
      </label>
    </div>
    <div *ngIf="!isCreditCard" class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Bank Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Bank Name"
            formControlName="bankName"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('bankName')!.touched &&
              addBankAccountForm.get('bankName')!.hasError('required')
            "
          >
            Bank name is required.
          </mat-error>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Account Number <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter account number"
            formControlName="accountNumber"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('accountNumber')!.touched &&
              addBankAccountForm.get('accountNumber')!.hasError('required')
            "
          >
            Account number is required.
          </mat-error>
          <mat-error
            *ngIf="
              addBankAccountForm.get('accountNumber')!.touched &&
              addBankAccountForm.get('accountNumber')!.hasError('pattern')
            "
          >
            Account number cannot contain special characters
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Account Type <span class="red">*</span></label>
        <mat-form-field>
          <mat-label>Choose Account Type</mat-label>
          <mat-select formControlName="accountType">
            <mat-option
            *ngFor="let type of bankAccountsData"
            [value]="type.value"
          >
            {{ type.label }}
          </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('accountType')!.touched &&
              addBankAccountForm.get('accountType')!.hasError('required')
            "
          >
            Account type is required.
          </mat-error>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Currency <span class="red">*</span></label>
        <mat-form-field>
          <mat-select placeholder="Select Currency" formControlName="currency">
            <mat-option
              *ngFor="let currency of currencyData"
              [value]="currency.currencyCode"
            >
              {{ currency?.currencyCode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('currency')!.touched &&
              addBankAccountForm.get('currency')!.hasError('required')
            "
          >
            Currency is required.
          </mat-error>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Opening Balance</label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter amount"
            formControlName="openingBalance"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('openingBalance')!.touched &&
              addBankAccountForm.get('openingBalance')!.hasError('required')
            "
          >
            Opening balance is required.
          </mat-error>
        </div>
      </div>
    </div>

    <!-- for CARD -->
    <div *ngIf="isCreditCard" class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Card Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Card Name"
            formControlName="cardName"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('cardName')!.touched &&
              addBankAccountForm.get('cardName')!.hasError('required')
            "
          >
            Card name is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Card Number <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter card number without hyphens"
            formControlName="cardNumberMasked"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('cardNumberMasked')!.touched &&
              addBankAccountForm.get('cardNumberMasked')!.hasError('required')
            "
          >
            Card number is required.
          </mat-error>
        
          <mat-error
            *ngIf="
              addBankAccountForm.get('cardNumberMasked')!.touched &&
              addBankAccountForm.get('cardNumberMasked')!.hasError('pattern')
            "
          >
            Card number cannot contain alphabets or special characters.
          </mat-error>
        
          <mat-error
            *ngIf="
              addBankAccountForm.get('cardNumberMasked')!.touched &&
              addBankAccountForm.get('cardNumberMasked')!.hasError('cardLength')
            "
          >
            Card number must be between 10 and 20 digits (excluding spaces).
          </mat-error>
        </div>
        
      </div>

      <div class="form-wrapper">
        <label for="">Issuer <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter issuer name"
            formControlName="issuer"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('issuer')!.touched &&
              addBankAccountForm.get('issuer')!.hasError('required')
            "
          >
            Issuer is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Currency <span class="red">*</span></label>
        <mat-form-field>
          <mat-select
            placeholder="Select Currency"
            formControlName="cardCurrency"
          >
            <mat-option
              *ngFor="let currency of currencyData"
              [value]="currency.currencyCode"
            >
              {{ currency?.currencyCode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('cardCurrency')!.touched &&
              addBankAccountForm.get('cardCurrency')!.hasError('required')
            "
          >
            Currency is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Credit Limit</label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter credit limit"
            formControlName="creditLimit"
            type="number"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('creditLimit')!.touched &&
              addBankAccountForm.get('creditLimit')!.hasError('required')
            "
          >
            Credit limit is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Current Balance</label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter current balance"
            formControlName="currentBalance"
            type="number"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('currentBalance')!.touched &&
              addBankAccountForm.get('currentBalance')!.hasError('required')
            "
          >
            Current balance is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Expiry Date</label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="expiryPicker"
            formControlName="expiryDate"
            placeholder="Select expiry date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="expiryPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #expiryPicker></mat-datepicker>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addBankAccountForm.get('expiryDate')!.touched &&
              addBankAccountForm.get('expiryDate')!.hasError('required')
            "
          >
            Expiry date is required.
          </mat-error>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="cmn-next-btn" (click)="onSave()">Save</button>
    </div>
  </form>
</section>
